module.exports = "https://static.wmbcdn.com/uniweb/images/bbc7a6ea498a144bb9cad78727166ef6.svg";